/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeProject_ProjectVersions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Project Version Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, June 17, 2019 - 09:49:02 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      06/17/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const PROJECTVERSION_LIST_CONTAINER_LOADED = 'PROJECTVERSION_LIST_CONTAINER_LOADED';
export const PROJECTVERSION_LIST_CONTAINER_UNLOADED = 'PROJECTVERSION_LIST_CONTAINER_UNLOADED';
export const PROJECTVERSION_LIST_TABLE_LOADED = 'PROJECTVERSION_LIST_TABLE_LOADED';
export const PROJECTVERSION_LIST_TABLE_UNLOADED = 'PROJECTVERSION_LIST_TABLE_UNLOADED';

export const PROJECTVERSION_LIST_CHANGE_GROUP = 'PROJECTVERSION_LIST_CHANGE_GROUP';
export const PROJECTVERSION_SELECT_ROW = 'PROJECTVERSION_SELECT_ROW';

export const PROJECTVERSION_ADD = 'PROJECTVERSION_ADD';
export const PROJECTVERSION_EDIT = 'PROJECTVERSION_EDIT';
export const PROJECTVERSION_DELETE = 'PROJECTVERSION_DELETE';
export const PROJECTVERSION_OPEN_WARNING = 'PROJECTVERSION_OPEN_WARNING';
export const PROJECTVERSION_CLOSE_WARNING = 'PROJECTVERSION_CLOSE_WARNING';
export const PROJECTVERSION_DELETE_DISABLE = 'PROJECTVERSION_DELETE_DISABLE';
export const PROJECTVERSION_VIEW_CHILD_ITEMS = 'PROJECTVERSION_VIEW_CHILD_ITEMS';

export const PROJECTVERSION_UPDATE_VALUE = 'PROJECTVERSION_UPDATE_VALUE';

export const PROJECTVERSION_EDIT_CONTAINER_LOADED = 'PROJECTVERSION_EDIT_CONTAINER_LOADED';
export const PROJECTVERSION_EDIT_CONTAINER_UNLOADED = 'PROJECTVERSION_EDIT_CONTAINER_UNLOADED';
export const PROJECTVERSION_EDIT_FORM_LOADED = 'PROJECTVERSION_EDIT_FORM_LOADED';
export const PROJECTVERSION_EDIT_FORM_UNLOADED = 'PROJECTVERSION_EDIT_FORM_UNLOADED';

export const PROJECTVERSION_SET_GROUP_SELECT = 'PROJECTVERSION_SET_GROUP_SELECT';
export const PROJECTVERSION_EDIT_DATA_LOAD = 'PROJECTVERSION_EDIT_DATA_LOAD';

export const PROJECTVERSION_EDIT_CONTAINER_SUBMIT = 'PROJECTVERSION_EDIT_CONTAINER_SUBMIT';
export const PROJECTVERSION_EDIT_CONTAINER_CANCEL = 'PROJECTVERSION_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeProject_ProjectVersions.js